// removed by extract-text-webpack-plugin
module.exports = {"video":"_3McKlaKl93Ao62-Szbn52z","content":"_12QiIS-Mn41hz0uVcxgIY-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/content-video/ContentVideo.css
// module id = 383
// module chunks = 0